<header class="section-header">
  <h2>امضای الکتریکی</h2>
  <span>میانگین ولتاژ<span *ngIf="dayCount"> / {{ dayCount }} روز</span></span>
</header>
<app-chart [context]="chartContext"></app-chart>
<div class="legend">
  <span><i class="dot valid" aria-hidden="true"></i> میانگین روزانه</span>
  <span><i class="dot missing" aria-hidden="true"></i> روز فاقد داده</span>
</div>
<p class="chart-note">فقط روزهای دارای دادهٔ معتبر الکتریکی رسم می‌شوند؛ فاصله‌های بدون داده با خط به هم وصل نمی‌شوند.</p>
